import * as React from 'react';
import { Form } from '../index';
import clsx from 'clsx';

type NativeProps = React.ComponentProps<typeof Form.Check>;
type CheckboxProps = Pick<
  NativeProps,
  | 'onChange'
  | 'value'
  | 'name'
  | 'label'
  | 'isInvalid'
  | 'checked'
  | 'disabled'
  | 'defaultChecked'
> & {
  id: string;
  size?: 'sm' | 'md' | 'lg';
  indeterminate?: boolean;
};
const Checkbox: React.FC<CheckboxProps> = ({
  size = 'sm',
  indeterminate,
  ...props
}) => {
  const checkboxRef = React.useRef<HTMLInputElement>(null);
  React.useEffect(() => {
    if (checkboxRef.current) {
      checkboxRef.current.indeterminate = indeterminate || false;
    }
  }, [indeterminate]);

  return (
    <Form.Check
      ref={checkboxRef}
      {...props}
      className={clsx(
        'mt-1 d-flex align-items-center form-label-nogutter space-x-2',
        size,
      )}
      id={props.id || props.name}
      data-cy={props.name}
      onClick={(e) => {
        e.stopPropagation();
      }}
      type='checkbox'
    />
  );
};

export default Checkbox;
